import { useMemo } from 'react';

import type { Id } from '@e-socna/data-layer';

import { externalQuotationInternalActorsOf } from '../utils/quotation-case.util';
import type { MissionForm_Mission } from '../fragments/mission.fragment';

import { useQuotationCollaboration } from './useQuotationCollaboration.hook';

export type SubMissionTurnLists = Readonly<
  Pick<MissionForm_Mission, 'internalActors' | 'externalActors'>
>;

// A sub-mission turned into a collaboration becomes its first sub-mission, in
// external quotation: the new collaboration takes the lists of the former one,
// the sub-mission the lists of an external quotation in it.
export const useSubMissionTurnLists = (
  formerCollaborationId: Id | null,
): SubMissionTurnLists | undefined => {
  const { collaborationEmitter, hasSeveralInternalActors } =
    useQuotationCollaboration(formerCollaborationId);

  return useMemo(
    () =>
      formerCollaborationId
        ? {
            internalActors: externalQuotationInternalActorsOf(
              collaborationEmitter,
              hasSeveralInternalActors,
            ),
            externalActors: null,
          }
        : undefined,
    [collaborationEmitter, formerCollaborationId, hasSeveralInternalActors],
  );
};
